module.exports = __webpack_public_path__ + "img/電気回路_2_9_5.b996a817.png";